import { GroupedNotesModel } from '@/models/student-notes/note.model';
import { SharedNotebook } from '@/models/student-notes/shared-notebook.model';

export interface NoteState {
  videoNotes: { [key: string]: any };
  homeNotes: { [key: string]: any };
  classVideoNotes: { [key: string]: any };
  groupedNotebookNotes: GroupedNotesModel[];
  isLoadingSharedNotebook: boolean;
  sharedNotebook: SharedNotebook | null;
  otherStudentSharedNotebook: SharedNotebook | null;
  isLoadingNotebookNotes: boolean;
  isGeneratingSharedNotebookLink: boolean;
  isLoadingNotes: boolean;
  isLoadingNewNoteSave: boolean;
  isConfirmationBoxOpened: boolean;
  isDeletingAnnotation: boolean;
}

const state: NoteState = {
  videoNotes: {},
  homeNotes: {},
  classVideoNotes: {},
  sharedNotebook: null,
  otherStudentSharedNotebook: null,
  groupedNotebookNotes: [],
  isLoadingSharedNotebook: false,
  isLoadingNotebookNotes: false,
  isGeneratingSharedNotebookLink: false,
  isLoadingNotes: false,
  isLoadingNewNoteSave: false,
  isConfirmationBoxOpened: false,
  isDeletingAnnotation: false,
};

export default state;
